import Environment from '@interfaces/environment.interface'
import onEnvironmentChange from '@observables/environment.observable'
import LogService from '@services/log/log.service'
import { take } from 'rxjs/operators'
import MainService from '../main/main.service'

export default class VidaDeInfluencerService extends MainService {
  url: string
  logService = new LogService()

  constructor(vidaDeInfluencerUrl?: string) {
    super()
    if (!vidaDeInfluencerUrl) {
      onEnvironmentChange.pipe(take(1)).subscribe((environment: Environment) => {
        this.url = environment?.squidProducts?.vidaDeInfluencer
      })
    } else {
      this.url = vidaDeInfluencerUrl
    }
    this.logService.init('Vida de Influencer Service')
  }

  public async getPosts({ page = 1, page_size = 5, sort_field = 'published', sort_order = 'DESC' }): Promise<any> {
    return await this.http
      .get(`${this.url}/API/article?page=${page}&page_size=${page_size}&sort_field=${sort_field}&sort_order=${sort_order}`)
      .then((r: any) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on get posts',
          error,
        })
        throw error.response
      })
  }
}
